module.exports = __webpack_public_path__ + "img/rob_6dof.92f7e2d9.png";